import {
	manipulateDigitalData,
	sendBeacon,
	trackVirtualPageview,
} from '@ao-internal/digital-data';

import {
	ADD_PRODUCT_TO_COMPARE,
	ADD_TO_BASKET_EVENT,
	FACET_SELECTED,
	FACET_TOGGLED,
	GOT_LISTER,
	LISTER_CLICK_THROUGH,
	REMOVE_PRODUCT_FROM_COMPARE,
	SET_PRODUCT_CARD_VIEW,
	SHOW_FILTERED_PRODUCTS,
	SORT_OPTION_CHANGED,
} from '../actions/lister-actions';
import { formatSelectedFacetForTagging } from '../utilities/lister-utilities';

export const taggingMiddleWare = (store) => (next) => (action) => {
	next(action);

	const { facets, pageTitle, products, productCardView } = store.getState();

	const getProductById = (ProductCode) =>
		products.find(({ Code }) => Code === ProductCode) ?? {};

	const getProductIndexById = (ProductCode) =>
		products.findIndex(({ Code }) => Code === ProductCode);

	switch (action.type) {
		case FACET_TOGGLED:
			const selectedBrandFacetNames = facets
				.find(({ Id }) => Id === 'brandname')
				?.FacetValues.filter(({ Selected }) => Selected)
				.map(({ Name }) => Name);

			manipulateDigitalData({
				page: {
					productDiscovery: {
						listerPage: {
							brand: selectedBrandFacetNames?.[0],
						},
					},
				},
			});

			sendBeacon('listerBrand');

			break;

		case FACET_SELECTED:
			const {
				storeSelectedFacets,
				facetValue: { Selected } = {},
			} = action.payload;

			const selectedFacet = {
				...action.payload,
				pageUrl: window.location.pathname,
			};

			//TODO: Remove this once analytics have update to use data that is passed
			const formattedFacetString = formatSelectedFacetForTagging(selectedFacet);

			if (!storeSelectedFacets && !Selected) {
				sendBeacon('listerFacet', {
					facet: formattedFacetString,
					data: action.payload,
				});
			}

			break;

		case SHOW_FILTERED_PRODUCTS:
			const selectedFacets = action.payload;
			// eslint-disable-next-line no-unused-expressions
			selectedFacets?.forEach((facet) =>
				sendBeacon('listerFacets', {
					facets: facet,
				})
			);
			break;

		case SORT_OPTION_CHANGED:
			const { sortPhrase } = action.payload;

			sendBeacon('listerSortBy', {
				filter: `${sortPhrase}|${pageTitle}`,
			});
			break;

		case ADD_PRODUCT_TO_COMPARE:
			sendBeacon('lpAddToCompare', 'Compare clicked');
			break;

		case REMOVE_PRODUCT_FROM_COMPARE:
			sendBeacon('lpRemoveFromCompare', 'Compare clicked');
			break;

		case SET_PRODUCT_CARD_VIEW:
			if (!action.hasInitialized) return;

			const cardView = action.payload;

			// Sends either 'listViewClicked' or 'gridViewClicked'
			sendBeacon(`${cardView}ViewClicked`, cardView);

			manipulateDigitalData({
				page: {
					pageInfo: {
						productView: cardView,
					},
				},
			});
			break;

		case ADD_TO_BASKET_EVENT: {
			const { eventName, ProductCode } = action.payload;

			const selectedProduct = getProductById(ProductCode);
			const { IsTop5, IsTradingRange } = selectedProduct;

			const position = getProductIndexById(ProductCode);
			const bestBuy = IsTop5;
			const tradingRange = IsTradingRange;

			// Position | BestBuy | TradingRange
			const productDetails = `${position}|${bestBuy}|${tradingRange}`;

			sendBeacon(eventName, {
				area: 'add to basket',
				productDetails,
				...selectedProduct,
				position,
				bestBuy,
				tradingRange,
			});
		}
		break;

		case GOT_LISTER:
			trackVirtualPageview();

			manipulateDigitalData({
				product: null,
				page: {
					pageInfo: {
						categoryListedProducts: null
					}
				}
			});

			manipulateDigitalData({
				product: products.map((product) => ({
					productInfo: product,
				})),
				page: {
					pageInfo: {
						productView: productCardView,
						categoryListedProducts: products.map((product) => product.Code)
					},
				},
			});

			break;

		case LISTER_CLICK_THROUGH:
			{
				const { productID } = action.payload;

				localStorage.setItem('selectedSku', productID);

				const product = getProductById(productID);

				const { Code, IsTop5, IsFeaturedProduct, State, IsTradingRange } = product;

				const position = getProductIndexById(productID);

				const cleanUrl = window.location.href
					?.replace(/(^\w+:|^)\/\//, '')
					.split('?')[0];

				const productCardType = IsFeaturedProduct ? 'Recommended' : 'Standard';
				const bestBuy = IsTop5;
				const tradingRange = IsTradingRange;
						
				// ProductSKU | Position | BestBuy | TradingRange |LocationOfClick | ListerViewType | CleanURL | StockStatus | ProductCardType
				const productDetails = `${Code}|${position}|${bestBuy}|${tradingRange}|Product card|${productCardView}|${cleanUrl}|${State}| ${productCardType}`;

				sendBeacon('listerClickThrough', {
					area: 'add to basket',
					productDetails,
					...product,
					position,
					bestBuy,
					tradingRange,
				});
			}
			break;

		default:
			break;
	}
};
